const endpoints = {
  loadSimulation: (id: string): string => `distributions?strategy=${id}`,
};

export default endpoints;
